export default __webpack_public_path__ + "static/media/hero.c029829a.png";